class InvoiceRequest extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.formId);
    this.toggle = this.querySelector('[data-invoice-toggle]');
    this.fields = this.querySelector('[data-invoice-fields]');
    this.fieldset = this.querySelector('[data-invoice-fieldset]');
    this.errors = this.querySelector('[data-invoice-errors]');
    this.recipientInputs = [...this.querySelectorAll('[data-invoice-recipient]')];
    this.valueInputs = [...this.querySelectorAll('[data-invoice-input]')];
    this.hiddenAttributes = [...this.querySelectorAll('[data-invoice-attribute]')];
    this.individual = this.querySelector('[data-invoice-individual]');
    this.company = this.querySelector('[data-invoice-company]');
    this.persistTimer = null;

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.addEventListener('change', this.onChange);
    this.addEventListener('input', this.onChange);
    this.form?.addEventListener('submit', this.onSubmit);
    this.syncState();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    this.removeEventListener('input', this.onChange);
    this.form?.removeEventListener('submit', this.onSubmit);
    window.clearTimeout(this.persistTimer);
  }

  get recipientType() {
    return this.recipientInputs.find((input) => input.checked)?.value || 'individual';
  }

  onChange(event) {
    if (!event.target.matches('[data-invoice-toggle], [data-invoice-recipient], [data-invoice-input]')) return;
    this.syncState();
    window.clearTimeout(this.persistTimer);
    this.persistTimer = window.setTimeout(() => this.persist(), 350);
  }

  onSubmit(event) {
    if (!this.validate()) {
      event.preventDefault();
      this.errors.focus();
      return;
    }
    this.syncAttributes();
  }

  syncState() {
    const requested = this.toggle.checked;
    const company = this.recipientType === 'company';
    this.fields.hidden = !requested;
    this.fieldset.disabled = !requested;
    this.individual.hidden = company;
    this.company.hidden = !company;
    this.querySelector('[data-invoice-input="invoice_individual_name"]').required = requested && !company;
    this.querySelector('[data-invoice-input="invoice_company_name"]').required = requested && company;
    this.querySelector('[data-invoice-input="invoice_registration_number"]').required = requested && company;
    this.querySelector('[data-invoice-input="invoice_billing_address"]').required = requested;
    this.querySelector('[data-invoice-input="invoice_email"]').required = requested;
    this.syncAttributes();
    this.errors.hidden = true;
    this.errors.textContent = '';
  }

  syncAttributes() {
    const values = Object.fromEntries(this.valueInputs.map((input) => [input.dataset.invoiceInput, input.value.trim()]));
    const attributes = {
      invoice_request: this.toggle.checked ? 'true' : '',
      invoice_recipient_type: this.toggle.checked ? this.recipientType : '',
      invoice_individual_name: this.toggle.checked && this.recipientType === 'individual' ? values.invoice_individual_name : '',
      invoice_company_name: this.toggle.checked && this.recipientType === 'company' ? values.invoice_company_name : '',
      invoice_registration_number: this.toggle.checked && this.recipientType === 'company' ? values.invoice_registration_number : '',
      invoice_billing_address: this.toggle.checked ? values.invoice_billing_address : '',
      invoice_email: this.toggle.checked ? values.invoice_email : '',
    };
    this.hiddenAttributes.forEach((input) => {
      input.value = attributes[input.dataset.invoiceAttribute] || '';
    });
    return attributes;
  }

  validate() {
    if (!this.toggle.checked) return true;
    const required = this.valueInputs.filter((input) => input.required);
    const invalid = required.find((input) => !input.checkValidity());
    if (!invalid) return true;
    invalid.focus();
    this.errors.textContent = this.dataset.validationMessage;
    this.errors.hidden = false;
    return false;
  }

  async persist() {
    const invoiceAttributes = this.syncAttributes();
    try {
      const cartResponse = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      await fetch(routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { ...(cart.attributes || {}), ...invoiceAttributes } }),
      });
    } catch (error) {
      this.errors.textContent = this.dataset.saveMessage;
      this.errors.hidden = false;
    }
  }
}

customElements.define('invoice-request', InvoiceRequest);
